/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergenzaCreateDTO
 */
export interface EmergenzaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof EmergenzaCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaCreateDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmergenzaCreateDTO
     */
    dataFine?: Date;
    /**
     * 
     * @type {string}
     * @memberof EmergenzaCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the EmergenzaCreateDTO interface.
 */
export function instanceOfEmergenzaCreateDTO(value: object): value is EmergenzaCreateDTO {
    return true;
}

export function EmergenzaCreateDTOFromJSON(json: any): EmergenzaCreateDTO {
    return EmergenzaCreateDTOFromJSONTyped(json, false);
}

export function EmergenzaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'dataFine': json['dataFine'] == null ? undefined : (new Date(json['dataFine'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function EmergenzaCreateDTOToJSON(value?: EmergenzaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio']).toISOString()),
        'dataFine': value['dataFine'] == null ? undefined : ((value['dataFine'] as any).toISOString()),
        'note': value['note'],
    };
}

